import { ContentFormatV2 } from "../v2/content_format";
import { TemplateFormatV2 } from "../v2/template_format";
import { ContentFormatV3 } from "../v3/content_format";
import { TemplateFormatV3 } from "../v3/template_format";

export function upgradeContentToV3(contentFormat: ContentFormatV2): ContentFormatV3 {
  return { ...contentFormat, definition_version: 3 };
}

export function upgradeTemplateToV3(templateFormat: TemplateFormatV2): TemplateFormatV3 {
  return { ...templateFormat, definition_version: 3 };
}
